import { render, staticRenderFns } from "./AddLayoutForm.vue?vue&type=template&id=253dd28f&scoped=true"
import script from "./AddLayoutForm.vue?vue&type=script&lang=js"
export * from "./AddLayoutForm.vue?vue&type=script&lang=js"
import style0 from "./AddLayoutForm.vue?vue&type=style&index=0&id=253dd28f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253dd28f",
  null
  
)

export default component.exports